export const ICP_GOOD_SCORE = 4
